import { render, staticRenderFns } from "./stuContact_zhzz.vue?vue&type=template&id=7a792197&scoped=true&"
import script from "./stuContact_zhzz.vue?vue&type=script&lang=js&"
export * from "./stuContact_zhzz.vue?vue&type=script&lang=js&"
import style0 from "./stuContact_zhzz.vue?vue&type=style&index=0&id=7a792197&prod&lang=less&"
import style1 from "./stuContact_zhzz.vue?vue&type=style&index=1&id=7a792197&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a792197",
  null
  
)

export default component.exports